import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import A1 from '../Login/Chatbot.jpeg'

const Sidebar = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [userName, setUserName] = useState('User Name');
  const navigate = useNavigate();

  useEffect(() => {
    const user = sessionStorage.getItem('user');
    if (user) {
      try {
        const userObj = JSON.parse(user);
        setUserName(userObj.name || 'User Name');
      } catch (error) {
        console.error('Error parsing user from sessionStorage', error);
      }
    }
  }, []);

  const menuItems = [
    { path: '/dashboard', icon: 'fa-tachometer-alt', label: 'Dashboard' },
    {
      path: '/message-templates',
      icon: 'fa-envelope',
      label: 'Message Templates',
      children: [
        { path: '/message-templates', label: 'Templates' },
        { path: '/add-templates', label: 'ADD Templates' }
      ]
    },
    {
      path: '/singlecontacts', icon: 'fa-address-book', label: 'Contacts',
      children: [
        { path: '/singlecontacts', label: 'Single contact' },
        { path: '/Add-new', label: 'Group contact' },
        // { path: '/list-tags', label: 'List&Tags' },
        // { path: '/import-export', label: 'Import/Export' }
      ]
    },
    // {
    //   path: '/notifications',
    //   icon: 'fa-bell',
    //   label: 'Notifications',
    //   children: [
    //     { path: '/notifications', label: 'Notifications' },
    //     { path: '/add-notification', label: 'Add New' },
    //   ]
    // },
    {
      path: '/analytics', icon: 'fa-chart-line', label: 'Analytics',
      children: [
        { path: '/messaging', label: 'Messaging' },
        { path: '/notificationss', label: 'Notifications' },
        { path: '/message-templates-analytics', label: 'Message Templates' },
      ]
    },
    // {
    //   path: '/automations', icon: 'fa-cogs', label: 'Automations',
    //   children: [
    //     { path: '/basic', label: 'Basic' },
    //     { path: '/auto-replies', label: 'Auto Replies' },
    //   ]
    // },
    // {
    //   path: '/inbox', icon: 'fa-inbox', label: 'Inbox',
    //   children: [
    //     { path: '/inbox', label: 'Inbox' },
    //   ]
    // },
  ];

  const toggleSubMenu = (index) => {
    setOpenMenu(openMenu === index ? null : index);
  };


  return (
    <div style={{ width: '250px', height: '100vh', backgroundColor: '#075E54', color: 'white', display: 'flex', flexDirection: 'column', padding: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
        <img src={A1} alt="Logo" className="me-2" style={{ width: '90px', borderRadius: '50%' }} />
        <span style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>eMedha Chatbot Services</span>
      </div>

      <div
        style={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '20px', cursor: 'pointer', borderRadius: '5px', }}
        onClick={() => navigate('/profile')}
      >
        <i className="fas fa-user-circle fa-2x"></i>
        <span style={{ fontSize: '1rem', fontWeight: 'bold', marginLeft: '10px' }}>{userName}</span>
      </div>

      <nav>
        <ul className="list-unstyled">
          {menuItems.map((item, index) => (
            <li key={index} className="mb-2">
              <div
                style={{ display: 'flex', alignItems: 'center', padding: '10px', color: 'white', textDecoration: 'none', borderRadius: '5px', cursor: 'pointer' }}
                onClick={(e) => {
                  if (item.children) {
                    toggleSubMenu(index);
                  } else {
                    navigate(item.path);
                  }
                }}
                className="d-flex align-items-center justify-content-between"
              >
                <div>
                  <i className={`fas ${item.icon} me-2`}></i>
                  {item.label}
                </div>
                {item.children && (
                  <i
                    className={`fas fa-chevron-${openMenu === index ? 'up' : 'down'}`}
                  ></i>
                )}
              </div>
              {item.children && openMenu === index && (
                <ul style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column' }} className="list-unstyled">
                  {item.children.map((child, childIndex) => (
                    <li key={childIndex}>
                      <Link
                        to={child.path}  // Correct navigation for child links
                        className="d-block text-white py-1 ps-3"
                        style={{ textDecoration: 'none' }}
                      >
                        - {child.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
